import { render, staticRenderFns } from "./PromocionBlackFriday2025.vue?vue&type=template&id=12c28965&scoped=true&"
import script from "./PromocionBlackFriday2025.vue?vue&type=script&lang=js&"
export * from "./PromocionBlackFriday2025.vue?vue&type=script&lang=js&"
import style0 from "./PromocionBlackFriday2025.vue?vue&type=style&index=0&id=12c28965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c28965",
  null
  
)

export default component.exports